import { BREAKPOINTS } from '../constants';
import { WindowService } from '../services/window.service';

export function onResize() {
  const windowService = new WindowService();
  const windowWidth = windowService.nativeWindow.innerWidth;

  return windowWidth < BREAKPOINTS.MEDIUM;
}
